export default {
    EXIGE_REGISTRO_NA_APAC_DE_DADOS_COMPLEMENTARES: '022',
    APAC_COM_VALIDADE_FIXA_DE_03_COMPETENCIAS: '033',
    APAC_COM_VALIDADE_FIXA_DE_2_COMPETENCIAS: '054',
    EXIGE_DATA_DO_RESULTADO_DIAGNOSTICO_DE_NEOPLASIA: '055',
}